import { Trans } from "react-i18next";

export const STATUSES = {
  COMPLETED: "COMPLETED",
  PRECONDITION_FAILED: "PRECONDITION_FAILED",
  ERROR: "ERROR",
  CANCELLED: "CANCELLED",
  FAIL: "FAIL",
  INTERNET: "INTERNET",
  FORBIDDEN: "FORBIDDEN",
  METHOD_NOT_ALLOWED: "METHOD_NOT_ALLOWED",
  CONFLICT: "CONFLICT",
  NOT_FOUND: "NOT_FOUND",
  GONE: "GONE",
  UNPROCESSABLE_ENTITY: "UNPROCESSABLE_ENTITY",
  // Numeric status codes

  PAYMENT_CANCELLED: 100,
  INSUFFICIENT_FUNDS: 2216,
  PAYMENT_PROGRESS: 2100,
  ORDER_PAID: 2103,
  ORDER_PAID_ALT: 2108,
  ORDER_IN_PROGRESS: 2101,
  ORDER_EXPIRED: 6017,
  ORDER_EXPIRED_ALT: 2217,
  PAYMENT_PROGRESS_ALT: 6086,
  QR_ALREADY_GENERATED: 3142,
  GOOGLE_BOT_CHECK_FAILED: 3136,
  INSTALLMENT_USED: 1,
  RECIPIENT_BLOCKED: 2023,
  RECIPIENT_BLOCKED_ALT: 2029,
  QR_CHECK_ERROR: 6002,
  QR_CHECK_ERROR_ALT: 6005,
  EXTERNAL_QR_ERROR: 2355,
  WRONG_AMOUNT: 2359,
  ORDER_PAID_ALT2: 6087,
  NO_VALID: 6088,
  AUTH_FAILED: 2297,
  GENERAL_ERROR: 2298,
  GENERAL_ERROR_ALT: 2303,
  ISSUER_ERROR: 2299,
  PRODUCT_EXPIRED: 2104,
  PRODUCT_EXPIRED_ALT: 2105,
  PRODUCT_EXPIRED_ALT2: 2106,
  AMOUNT_RANGE: 2030,
  DEVEICE_ERRORS: {
    NO_DEVICE_ALT: 2279,
    NO_DEVICE_ALT2: 2308,
    NO_DEVICE_ALT3: 2309,
  },
  CARD_ERRORS: {
    INVALID_DATA: 2290,
    INVALID_DATA_ALT: 2300,
    NOT_FOUND: 2291,
    BLOCKED: 2292,
    EXPIRED: 2293,
    EXPIRED_ALT: 2302,
    NOT_SUPPORTED: 2294,
    BLOCKED_ALT: 2295,
  },
  LIMIT_ERRORS: {
    CRYPTO_LIMIT_REACHED: 2411,
    LIMIT_REACHED: 4005,
    LIMIT_REACHED_ALT: 4006,
    BENEFICIARY_LIMIT: 4002,
  },
  VAT_ERRORS: {
    BLOCKED: 4017,
  },
  VOUCHER_ERRORS: {
    ALREADY_CHOSEN: 1055,
  },
};

export const ERROR_GROUPS = {
  VALIDATION: 1,
  MISTAKE: 2,
  AUTH: 3,
  PROVIDER: 4,
  RESOURCE: 5,
  FORMAT: 6,
  INFO: 7,
  LIMITS: 8,
};

export const getStatusConfig = (type, group, t, currency) => {
  const defaultErrorConfig = {
    title: t("description.transactionFailed"),
    message: t("description.pleaseCheckFunds"),
    icon: "error",
  };

  const statusConfigs = {
    [STATUSES.COMPLETED]: {
      title: t("description.transactionComplete"),
      message: t("description.yourTipWasSentToServer"),
      icon: "success",
    },
    [STATUSES.ERROR]: defaultErrorConfig,
    [STATUSES.FAIL]: defaultErrorConfig,
    [STATUSES.CANCELLED]: defaultErrorConfig,
    [STATUSES.INTERNET]: {
      title: "Network Problem",
      message: "Please check your internet connection!",
      icon: "error",
    },
    [STATUSES.FORBIDDEN]: {
      title: t("Your VAT number is blocked!"),
      message: t("Contact Keepz support"),
      icon: "error",
    },
    [STATUSES.METHOD_NOT_ALLOWED]: {
      title: t("description.limitHeader"),
      message:
        "Beneficiary personal number reached limit of receiving payments!",
      icon: "error",
    },
    [STATUSES.CONFLICT]: {
      title: "დაფიქსირდა კონფლიქტი",
      message: "თქვენ სარგებლობთ გამოყენებული ორდერით",
      icon: "error",
    },
    [STATUSES.NOT_FOUND]: {
      title: "Order not found",
      message: t("description.qrCheckError"),
      icon: "error",
    },
    [STATUSES.PAYMENT_CANCELLED]: {
      title: t("description.paymentCancelled"),
      message: t("description.paymentCancelledDesc"),
      icon: "error",
    },
    [STATUSES.PAYMENT_PROGRESS]: {
      title: t("description.paymentProgress"),
      message: t("description.tryAgain"),
      icon: "error",
    },
    [STATUSES.ORDER_PAID]: {
      title: t("description.orderPaid"),
      icon: "alreadyPaid",
    },
    [STATUSES.INSUFFICIENT_FUNDS]: {
      title: t("description.notEnoughFunds"),
      icon: "error",
    },
    [STATUSES.ORDER_PAID_ALT]: {
      title: t("description.orderPaid"),
      icon: "alreadyPaid",
    },
    [STATUSES.ORDER_IN_PROGRESS]: {
      message: t("description.orderInProgress"),
      icon: "error",
    },
    [STATUSES.ORDER_EXPIRED]: {
      title: t("description.orderExpired"),
      icon: "error",
    },
    [STATUSES.ORDER_EXPIRED_ALT]: {
      title: t("description.orderExpired"),
      icon: "error",
    },
    [STATUSES.PAYMENT_PROGRESS_ALT]: {
      message: t("description.paymentProgress"),
      icon: "error",
    },
    [STATUSES.QR_ALREADY_GENERATED]: {
      message: "QR already generated",
      icon: "error",
    },
    [STATUSES.GOOGLE_BOT_CHECK_FAILED]: {
      message: "Google bot check failed",
      icon: "error",
    },
    [STATUSES.INSTALLMENT_USED]: {
      title: "Installment already used",
      icon: "error",
    },
    [STATUSES.RECIPIENT_BLOCKED]: {
      title: t("description.recipientBlocked"),
      icon: "error",
    },
    [STATUSES.RECIPIENT_BLOCKED_ALT]: {
      title: t("description.recipientBlocked"),
      icon: "error",
    },
    [STATUSES.QR_CHECK_ERROR]: {
      message: t("description.qrCheckError"),
      icon: "error",
    },
    [STATUSES.QR_CHECK_ERROR_ALT]: {
      message: <Trans i18nKey={"description.orderExpired"} />,
      icon: "error",
    },
    [STATUSES.EXTERNAL_QR_ERROR]: {
      message: t("description.externalQrError"),
      icon: "error",
    },
    [STATUSES.WRONG_AMOUNT]: {
      message: t("description.wrongAmount"),
      icon: "error",
    },
    [STATUSES.ORDER_PAID_ALT2]: {
      message: t("description.orderPaid"),
      icon: "alreadyPaid",
    },
    [STATUSES.NO_VALID]: {
      message: t("description.noValid"),
      icon: "error",
    },
    [STATUSES.AUTH_FAILED]: {
      message: "Authentication failed by client device",
      icon: "error",
    },
    [STATUSES.GENERAL_ERROR]: {
      message: t("description.generalError"),
      icon: "error",
    },
    [STATUSES.GENERAL_ERROR_ALT]: {
      message: t("description.generalError"),
      icon: "error",
    },
    [STATUSES.ISSUER_ERROR]: {
      message: t("description.issuerError"),
      icon: "error",
    },
    [STATUSES.PRODUCT_EXPIRED]: {
      title: t("description.productExpired"),
      icon: "error",
    },
    [STATUSES.PRODUCT_EXPIRED_ALT]: {
      title: t("description.productExpired"),
      icon: "error",
    },
    [STATUSES.PRODUCT_EXPIRED_ALT2]: {
      title: t("description.productExpired"),
      icon: "error",
    },
    [STATUSES.AMOUNT_RANGE]: {
      title: t("description.amountSholdBeInRange"),
      icon: "error",
    },
    // Card errors
    [STATUSES.CARD_ERRORS.INVALID_DATA]: {
      message: t("description.invalidCardData"),
      icon: "error",
    },
    [STATUSES.CARD_ERRORS.INVALID_DATA_ALT]: {
      message: t("description.invalidCardData"),
      icon: "error",
    },
    [STATUSES.CARD_ERRORS.NOT_FOUND]: {
      message: t("description.cardNotFound"),
      icon: "error",
    },
    [STATUSES.CARD_ERRORS.BLOCKED]: {
      message: t("description.cardBlocked"),
      icon: "error",
    },
    [STATUSES.CARD_ERRORS.EXPIRED]: {
      message: t("description.cardExpired"),
      icon: "error",
    },
    [STATUSES.CARD_ERRORS.EXPIRED_ALT]: {
      message: t("description.cardExpired"),
      icon: "error",
    },
    [STATUSES.CARD_ERRORS.NOT_SUPPORTED]: {
      message: t("description.cardNotSupported"),
      icon: "error",
    },
    [STATUSES.CARD_ERRORS.BLOCKED_ALT]: {
      message: t("description.cardBlocked"),
      icon: "error",
    },
    // Limit errors
    [STATUSES.LIMIT_ERRORS.LIMIT_REACHED]: {
      title: t("description.limitHeader"),
      message: t("description.limitBody"),
      icon: "error",
    },
    [STATUSES.LIMIT_ERRORS.LIMIT_REACHED_ALT]: {
      title: t("description.transactionFailed"),
      message: t("description.limitBodyTwo"),
      icon: "error",
    },
    [STATUSES.LIMIT_ERRORS.BENEFICIARY_LIMIT]: {
      title: t("description.transactionFailed"),
      message: t("description.beneficarylimit"),
      icon: "error",
    },
    [STATUSES.LIMIT_ERRORS.CRYPTO_LIMIT_REACHED]: {
      message: t("description.cryptoLimitReached", { currency }),
      icon: "error",
    },
    // VAT errors
    [STATUSES.VAT_ERRORS.BLOCKED]: {
      message: t("description.ibanIsBlocked"),
      icon: "error",
    },
    // Voucher errors
    [STATUSES.VOUCHER_ERRORS.ALREADY_CHOSEN]: {
      message: "Voucher already chosen!",
      icon: "error",
    },
    [STATUSES.DEVEICE_ERRORS.NO_DEVICE_ALT]: {
      message: "Device us currently unavailable",
      icon: "error",
    },
    [STATUSES.DEVEICE_ERRORS.NO_DEVICE_ALT2]: {
      message: "Device us currently unavailable",
      icon: "error",
    },
    [STATUSES.DEVEICE_ERRORS.NO_DEVICE_ALT3]: {
      message: "Device us currently unavailable",
      icon: "error",
    },
  };

  const groupConfigs = {
    [ERROR_GROUPS.VALIDATION]: {
      message: <Trans i18nKey={"description.informationIsNotValid"} />,
      icon: "error",
    },
    [ERROR_GROUPS.MISTAKE]: {
      message: <Trans i18nKey={"description.mistake"} />,
      icon: "error",
    },
    [ERROR_GROUPS.AUTH]: {
      title: "Group 3",
      message: "AUTH group",
      icon: "error",
    },
    [ERROR_GROUPS.PROVIDER]: {
      message: <Trans i18nKey={"description.provideError"} />,
      icon: "error",
    },
    [ERROR_GROUPS.RESOURCE]: {
      message: <Trans i18nKey={"description.resourcesNotFound"} />,
      icon: "error",
    },
    [ERROR_GROUPS.FORMAT]: {
      message: t("description.formatError"),
      icon: "error",
    },
    [ERROR_GROUPS.INFO]: {
      message: <Trans i18nKey={"description.informationNotFound"} />,
      icon: "error",
    },
    [ERROR_GROUPS.LIMITS]: {
      message: <Trans i18nKey={"description.limitsProblem"} />,
      icon: "error",
    },
  };

  return statusConfigs[type] || groupConfigs[group] || defaultErrorConfig;
};
